import { cloneDeep } from "lodash"
import type { StateObject } from "../../../redux/types"
import { getCurrentPath } from "../../../router/selectors"
import { Router } from "../../../../server/router"
import type { ModifierGroupFormItem } from "../modifierGroups/ModifierGroupForm"
import type { ModifierSaveRequestData } from "../../../../graphql/types"

export const redirectBackToModifierGroupDetail = (state: StateObject) => {
    const currentUrlQuery = getCurrentPath(state).query
    const modifierGroupId = currentUrlQuery.id

    if (modifierGroupId) {
        Router.push(`/menu/modifier-groups/edit/${modifierGroupId}`)
    }
}

export const addModifierToModifierGroupData = (
    oldModifierGroupData: ModifierGroupFormItem,
    newModifierData: ModifierSaveRequestData
) => {
    const newValue: ModifierGroupFormItem = cloneDeep(oldModifierGroupData)
    newValue.items = [
        ...newValue.items,
        {
            modifierId: newModifierData.id,
            groupItemId: null,
            name: newModifierData.name,
            price: 0,
            groupExtra: 0,
            // @ts-expect-error
            locationOverrides: [],
            isActive: true,
        },
    ]
    return newValue
}

export const modifierDuplicateDescription =
    "Duplicate Modifier - General settings. It won't duplicate to which Modifier Groups the modifier is added."
